export interface TopAppsReportResponseDto {
  appId: string;
  totalDuration: string;
  name: string;
  logoUrl?: string;
  displayColor?: string;
  totalDurationVsAvgDurationPercentage: string;
}

export interface TopAppsReportV2ResponseDto {
  appId: string;
  totalDuration: string;
  totalDurationVsAvgDurationPercentage: string;
}